"use strict"

import React, { useEffect, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Button, ButtonGroup } from "react-bootstrap"

import { LanzaTable, UniversalFilter } from "../../shared_components/widgets/LanzaTable"
import { showModal } from "../../shared_components/utils"
import { displayRef } from "../widgets/utils"
import AddSourceTagsModal from "./modals/AddSourceTagsModal"
import EditSourceTagsModal from "./modals/EditSourceTagsModal"
import { addNewObject, updateObject } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"
import { withSourceRegistrationConfig } from "../../config/SourceRegistrationConfigProvider"

function _SourceTagsTable(props) {
  const intl = useIntl()
  const [tags, setTags] = useState([])

  const [addSourceTagsModal, setAddSourceTagsModal] = useState(false)
  const [newSourceTagsWarn, setNewSourceTagsWarn] = useState(false)

  const [editSourceTagsModal, setEditSourceTagsModal] = useState(false)
  const [editSourceTagsWarn, setEditSourceTagsWarn] = useState(false)

  useEffect(() => {
    setTags(props.source.tags)
  }, [props.source.tags])

  const generateNewSourceTags = (data, loaderRef, source_id) => {
    const info = {
      data: data,
      source_id: source_id,
    }

    addNewObject("/warehouse/source_tags/bulk_create/", info)
      .then((_) => {
        setAddSourceTagsModal(false)
        setNewSourceTagsWarn(false)
        props.resources.getSourceInfo()
      })
      .catch((err) => {
        displayRef(loaderRef, false)
        console.error(err)
        logToServer(err)
        setNewSourceTagsWarn(err)
      })
  }

  const editSourceTags = (data, loaderRef, source_id) => {
    const info = {
      data: data,
      source_id: source_id,
    }

    updateObject("/warehouse/source_tags/bulk_update/", info)
      .then((_) => {
        setEditSourceTagsModal(false)
        setEditSourceTagsWarn(false)
        props.resources.getSourceInfo()
      })
      .catch((err) => {
        displayRef(loaderRef, false)
        console.error(err)
        logToServer(err)
        setEditSourceTagsWarn(err)
      })
  }

  return (
    <React.Fragment>
      {addSourceTagsModal && (
        <AddSourceTagsModal
          show={addSourceTagsModal}
          onHide={() => setAddSourceTagsModal(false)}
          warning={newSourceTagsWarn}
          observation_types={props.observation_types}
          units={props.units}
          queryTags={props.queryTags}
          source={props.source}
          submitData={generateNewSourceTags}
        />
      )}
      {editSourceTagsModal && (
        <EditSourceTagsModal
          show={editSourceTagsModal}
          onHide={() => setEditSourceTagsModal(false)}
          warning={editSourceTagsWarn}
          observation_types={props.observation_types}
          units={props.units}
          queryTags={props.queryTags}
          source={props.source}
          submitData={editSourceTags}
        />
      )}
      <div className={"row"} style={{ marginBottom: "5px" }}>
        <div className={"col-8"}>
          <h5>
            <FormattedMessage
              id={"sourceregistration.manage.source.tags"}
              description={"Manage Source Tags Label"}
            />
            :
          </h5>
        </div>
        <div className={"col-4"}>
          <ButtonGroup style={{ float: "right" }}>
            {props.permissions.includes("change_sourcetag") && (
              <Button
                variant={"outline-primary"}
                onClick={(e) => {
                  e.preventDefault()
                  showModal(setEditSourceTagsModal)
                }}
                title={intl.formatMessage({
                  id: "sourceregistration.edit.source.tags",
                })}
                disabled={!props.source.tags || props.source.tags.length === 0}
              >
                <span className={"fa fa-pencil"} />
              </Button>
            )}
            {props.permissions.includes("add_sourcetag") && (
              <Button
                variant={"outline-primary"}
                onClick={(e) => {
                  e.preventDefault()
                  showModal(setAddSourceTagsModal)
                }}
                title={intl.formatMessage({
                  id: "sourceregistration.register.new.source.tags",
                })}
              >
                <span className={"fa fa-plus-circle"} />
              </Button>
            )}
          </ButtonGroup>
        </div>
      </div>
      <LanzaTable
        className="table table-bordered table-sm table-hover tbl_lanzatable"
        columns={[
          {
            Header: <FormattedMessage id="general.observation.type" />,
            accessor: "observation_type",
            Filter: ({ column, preFilteredRows }) => (
              <UniversalFilter
                column={column}
                setFilter={column.setFilter}
                preFilteredRows={preFilteredRows}
                filterType="select"
                isClearable={false}
              />
            ),
            filter: "equals",
            className: "text-center",
          },
          {
            Header: <FormattedMessage id="general.tag" defaultMessage={"Tag"} />,
            accessor: "tag",
            className: "text-center",
          },
          {
            Header: <FormattedMessage id="general.units" defaultMessage={"Units"} />,
            accessor: "units",
            Filter: ({ column, preFilteredRows }) => (
              <UniversalFilter
                column={column}
                setFilter={column.setFilter}
                preFilteredRows={preFilteredRows}
                filterType="select"
                isClearable={false}
              />
            ),
            filter: "equals",
            className: "text-center",
          },
          {
            Header: <FormattedMessage id="general.expiry" defaultMessage={"Expiry"} />,
            accessor: "expiry",
            className: "text-center",
            disableFilters: true,
            style: { maxWidth: "100px", width: "100px" },
          },
          {
            Header: <FormattedMessage id="general.status" defaultMessage={"Status"} />,
            id: "status",
            className: "text-center",
            disableSortBy: true,
            disableFilters: true,
            accessor: (tag) => {
              if (tag["status"] === "Error") {
                return (
                  <h5 className={"table_warning"}>
                    <span className="fa fa-times-circle-o text-danger" />
                  </h5>
                )
              } else {
                return (
                  <h5>
                    <span className="fa fa-check-circle-o text-success" />
                  </h5>
                )
              }
            },
          },
        ]}
        data={tags}
        allowSorting={true}
        allowFilters={true}
        initialTableOptions={{
          pageSize: 10,
        }}
      />
    </React.Fragment>
  )
}

const SourceTagsTable = withSourceRegistrationConfig(_SourceTagsTable)
export default SourceTagsTable
